// extracted by mini-css-extract-plugin
module.exports = {"form_block":"a10a3f92e9--form_block--2M7MH","submit_button":"a10a3f92e9--submit_button--Uor2P"};